// extracted by mini-css-extract-plugin
module.exports = {"answerChoicesContainer":"style-module__answerChoicesContainer___2ObUW"};